module.exports = __webpack_public_path__ + "static/media/Font Awesome 5 Pro 300.310d530b.otf";